import i18n from "i18next"
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from 'i18next-http-backend';
import { languagesArray } from "./languages";


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(Backend)
  .init({
    //debug: true,
    supportedLngs: languagesArray,
    fallbackLng: "es",
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json?lng={{lng}}&{{ns}}`,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    }
  })

export default i18n;
